import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";

interface IPopupTab {
  tab: number;
  setTab: Dispatch<SetStateAction<number>>;
}

export default function PopupTab({ tab, setTab }: IPopupTab) {
  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>
          팝업 알림 현황
        </PointTabText>

        <PopupTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>
          팝업 템플릿 관리
        </PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const PopupTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 103 : 120)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 122)}px;
`;
